(function($) {
  const $blocks = $('.block-single-gallery');

  $blocks.on('click', '.js-lightbox-link', function(event) {
    event.preventDefault();
    event.stopPropagation();

    var _this = event.currentTarget;
    var $block = $(_this).parents('.block-single-gallery');
    var index = $(_this).parents('.block-single-gallery__images__item').index();
    var imageset = [];

    $block.find('img').each(function() {
      var large = $(this).parents('.block-single-gallery__images__item').find('.js-lightbox-link').attr('href');
      imageset.push({
        src: large,
        opts: {
          $thumb: $(this),
          thumb: this.getAttribute('src'),
          caption: this.getAttribute('alt') || ''
        }
      })
    });

    $.fancybox.open( imageset, {}, index );
  });
})(jQuery);